import React from "react";
import styles from "./InitialLoadUI.module.scss";
// import proactlatestlogo from "../../../assets/images/intial-load-ui.gif";
import healthboxLoader from "../../../assets/images/intial-load-ui.gif";

const InitialLoadUI = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: `translate(${-50}%, ${-50}%)`,
        // width: "200px",
        width: "100px",
      }}
    >
      <img src={healthboxLoader} alt="logo" className={styles.imgStyle} />
    </div>
  );
};

export default InitialLoadUI;
